// extracted by mini-css-extract-plugin
export default {"link":"RewardsReport_link__tViNH","no_hover":"RewardsReport_no_hover__waTmb"};